import React, { useCallback } from 'react';
import { Input } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from 'ts/common/hooks';

interface CreditCardCVVInputProps {
    name: string;
    cardType?: string | null;
}

const LegacyCreditCardCVVInput: React.FC<CreditCardCVVInputProps> = ({ name, cardType }) => {
    const { register, setValue, watch } = useFormContext();
    const t = useTranslate('creditCards');
    const value = watch(name) || '';

    const getMaxLength = useCallback(() => {
        return cardType === 'amex' ? 4 : 3;
    }, [cardType]);

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const inputValue = e.target.value;
            const numericValue = inputValue.replace(/\D/g, '');
            setValue(name, numericValue);
        },
        [name, setValue]
    );

    const validateCVV = useCallback(
        (value: string) => {
            const expectedLength = cardType === 'amex' ? 4 : 3;

            if (value.length !== expectedLength) {
                return t('cvvLength');
            }

            if (!/^\d+$/.test(value)) {
                return t('cvvOnlyNumbers');
            }

            return true;
        },
        [cardType, t]
    );

    return (
        <Input
            {...register(name, {
                required: true,
                validate: validateCVV
            })}
            value={value}
            onChange={handleInputChange}
            maxLength={getMaxLength()}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
        />
    );
};

export default LegacyCreditCardCVVInput;
